import React, { useContext } from "react";
import { ConfigContext } from "../../App";
import Explanation from "../elements/Explanation";
import NextButton from "../elements/NextButton";
import OutsideColorButtonGroup from "../OutsideColorButtonGroup";
import TextButtonGroup from "../TextButtonGroup";
import TotalPrice from "../TotalPrice";

import logo from "../../vanchanger_logo_nebelblau.svg";

function getUnique( arr: any[], key: string ) {
	return arr.map( c => c[key] )
	          .filter( ( value, index, array ) => array.indexOf( value ) === index );
}

function Outside() {
	const config = useContext(ConfigContext);

	return <div className="flex configuration-part active">
		<div className="flex configuration-part-headline">
			<img className="part-headline-img"
				 src={logo}
				 alt="logo"/>
			<h2>Fahrzeug</h2>
		</div>

        <div className="category-container info">
            Dein VanChanger ohne Dachzelt kannst Du <a href={"https://vanchanger.de/html/kontaktformular.html"} target={"_blank"}>hier</a> unverbindlich anfragen
        </div>

		<TextButtonGroup heading={"Fahrzeuglänge"}
						 name={"length"}
						 elements={getUnique(config.car.car, "length")}
		/>
		<OutsideColorButtonGroup heading={"Außenfarbe"}
								 name={"outside_color"}
								 elements={config.carColorOutside}
		/>
		<TextButtonGroup heading={"Motorisierung"}
						 name={"engine"}
						 elements={getUnique(config.car.car, "engine")}
		/>
		<TextButtonGroup heading={"Getriebeart"}
						 name={"transmission"}
						 elements={getUnique(config.car.car, "transmission")}
		/>
		<TextButtonGroup fullwidth
						 heading={"Grundausstattung"}
						 name={"package"}
						 elements={config.carPackage.map(c => c.package)}
						 featureList={
							 config.carPackage
								 .map(c => c.info)
								 .map((i,index) => <div className="package-summary" key={`package-${index}`}>
										 <ul>
											 {i.map(e => <li key={e.item}>{e.item} {
												 e.info && (
													 typeof e.info === "string"
														 ? <Explanation>{e.info}</Explanation>
														 : <Explanation>{e.info.join(", ")}</Explanation>
												 )
											 }</li>)}
										 </ul>
									 </div>,
								 )
						 }
		/>

		<NextButton/>



	</div>;
}

export default Outside;
